(function($) {
	$(function() {
		if ( $('.testimonials-slider').length ) {
			const swiper = new Swiper('.testimonials-slider', {
				// Optional parameters
				direction: 'horizontal',
				loop: true,
				slidesPerView: 1,
				spaceBetween: 0,
			
				// Navigation arrows
				navigation: {
				nextEl: '.testimonials-slider-next',
				prevEl: '.testimonials-slider-prev',
				},

				// Breakpoints
				breakpoints: {
					768: {
						slidesPerView: 2,
						spaceBetween: 30,
					},
					1024: {
						slidesPerView: 3,
						spaceBetween: 40,
					},
				},

			});
		}
	});
})(jQuery);